/**
 * IONLOOP Assistant — action link selector.
 *
 * Gathers meaningful navigation links from the top search results, deduplicates
 * them, and picks the most relevant 1-3 actions for the user to click.
 *
 * Only actual indexed links are used — never invented.
 */

var tokenizer = require('../knowledge/tokenizer');

/**
 * Normalize a raw link label. If the label is uninformative ("Click here",
 * "Read more", empty), replace it with the page title or a generic label.
 */
function normalizeLabel(label, pageTitle) {
    var normalized = String(label || '').toLowerCase().trim();
    var weak = /^(click here|read more|learn more|view more|open|more|here|link|this|details|full story|view|go|visit|explore)/.test(normalized);
    if (weak && pageTitle) {
        var cleanTitle = pageTitle.replace(/\s*\|.*$/, '').trim();
        if (cleanTitle) {
            return 'Open ' + cleanTitle;
        }
    }
    return label;
}

/**
 * Assess how relevant a link label is to the user's query terms.
 */
function labelRelevance(label, queryTerms) {
    var lower = String(label || '').toLowerCase();
    var tokens = tokenizer.tokenize(lower);
    var score = 0;
    queryTerms.forEach(function (qt) {
        tokens.forEach(function (tok) {
            if (tok === qt) {
                score += 1;
            }
        });
        if (lower.indexOf(qt) !== -1) {
            score += 0.5;
        }
    });
    return score;
}

/**
 * Select the best 1..maxActions actions from the top search results.
 */
function selectActions(results, queryMeaningfulTerms, options) {
    options = options || {};
    var maxActions = options.maxActions || 3;
    var seen = {};
    var candidates = [];

    (results || []).forEach(function (result) {
        var sectionLinks = result.links || [];
        sectionLinks.forEach(function (link) {
            var url = link.url || '';
            if (seen[url]) {
                return;
            }
            // Skip javascript: / mailto: / data: URLs.
            if (/^javascript:/i.test(url) || /^mailto:/i.test(url) || /^data:/i.test(url) || url === '#') {
                return;
            }
            var label = normalizeLabel(link.label, result.title);
            // Skip verbose card-description links (poor action labels).
            if (label.length > 60) {
                return;
            }
            seen[url] = true;
            var relevance = labelRelevance(label, queryMeaningfulTerms || []);
            // Prefer concise labels.
            var wordCount = label.split(/\s+/).length;
            var concisionBonus = wordCount <= 4 ? 1.5 : (wordCount <= 8 ? 0.5 : -1);
            candidates.push({
                label: label,
                url: url,
                relevance: relevance + concisionBonus,
                sourceTitle: result.title
            });
        });
    });

    candidates.sort(function (a, b) { return b.relevance - a.relevance; });

    var top = candidates.slice(0, maxActions);
    // If no candidate had any relevance, take the first one anyway.
    if (top.length === 0 && candidates.length > 0) {
        top = [candidates[0]];
    }
    return top;
}

module.exports = {
    normalizeLabel: normalizeLabel,
    selectActions: selectActions
};